import api, { isHTTPError } from '../api'
import useDataLoader from '../dataLoader'

const useRequestVerificationEmail = () => {
  const requestVerificationEmail = async (email: string) => {
    try {
        return await api.requestVerificationEmail(email)
      } catch (error) {
        if (isHTTPError(error) && error.response && error.response.status === 404) {
          // @ts-ignore
          return error.response.data.detail.type
        } else if (isHTTPError(error) && error.response && 'detail' in error.response.data) {
            return error.response.data.detail.type
      }
    }
  }

  return useDataLoader(requestVerificationEmail, [], [])
}

export default useRequestVerificationEmail
